import React from 'react'
import { TableVirtuoso  } from 'react-virtuoso';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const columns = [
    { id: 'LParam', label: 'LParam',width:150},
    { id: 'RParam', label: 'RParam',width:150},
    { id: 'Actions', label: 'Actions',width:150}
];

const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
      <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableRow,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

function fixedHeaderContent() {
    return (
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.dataKey}
            variant="head"
            align={column.numeric || false ? 'right' : 'left'}
            style={{ width: column.width }}
            sx={{
              backgroundColor: 'background.paper',
            }}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
}

const MappingConnectionTable = ({data,handleClickOpen,handleRowDelete}) => {
    const tableHeight = data?.length === 1 ? 240 : data?.length === 2  ? 420 : 600;

    const Row = ({index}) => {
        const row = data[index];
        return (
            <>
                {columns.map((column) => {
                    const value = row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                                ? column.format(value) 
                                : column.id === 'Actions' ?
                                    <>
                                        <IconButton 
                                            color="inherit"
                                            title="Edit Data"
                                            onClick={()=> handleClickOpen(row)}
                                        >
                                            <EditRoundedIcon />
                                        </IconButton>
                                        <IconButton 
                                            color="error"
                                            title="Delete Row"
                                            onClick={()=> handleRowDelete(index)}
                                        >
                                            <DeleteRoundedIcon />
                                        </IconButton>
                                    </>
                                : value
                                }
                        </TableCell>
                    );
                })}
            </>
        )
    }



    return (
        <>
        { data?.length > 0 &&
            <Paper style={{ height:tableHeight,width: '100%' }}>            
                <TableVirtuoso 
                    className='TableVirtuoso'
                    totalCount={data?.length}
                    data={data}
                    components={VirtuosoTableComponents}
                    fixedHeaderContent={fixedHeaderContent}
                    itemContent={(index) => (<Row index={index} />)}
                    useWindowScroll={false}
                />   
            </Paper> 
        }
        </>
    )
}

export default MappingConnectionTable